(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/pay/to-api-wagers.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/pay/to-api-wagers.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  format
} = svs.utils;
const {
  productMapping
} = svs.numbergames;
function toPayableBoard(_ref) {
  var _board$extraNumbers$l, _board$extraNumbers;
  let {
    game,
    board
  } = _ref;
  const b = {
    numSelections: board.numbers.length + ((_board$extraNumbers$l = (_board$extraNumbers = board.extraNumbers) === null || _board$extraNumbers === void 0 ? void 0 : _board$extraNumbers.length) !== null && _board$extraNumbers$l !== void 0 ? _board$extraNumbers$l : 0),
    rowPriceMulti: board.rowPriceMulti || 1,
    boardProps: ['QUICKPICK'],
    systemType: ['SROW'],
    systemNum: 0
  };
  switch (board.productId) {
    case productMapping.CONSTANTS.LOTTO:
      b.boardData = board.numbers.map(n => n.number);
      b.participation = game.hasLotto2 ? 'L1L2' : 'L1';
      break;
    case productMapping.CONSTANTS.KENO:
      b.boardData = board.numbers.map(n => n.number);
      b.participation = (board.hasKungKeno ? 'KK' : 'K') + board.level;
      break;
    case productMapping.CONSTANTS.JOKER:
      b.boardData = board.numbers.map(num => num.number);
      b.participation = 0;
      break;
    default:
      b.boardData1 = board.numbers.map(n => n.number);
      b.boardData2 = board.extraNumbers.map(n => n.number);
      b.participation = 0;
  }
  return b;
}
const boardName = {
  KENO: 'kenoBoards',
  LOTTO: 'lottoBoards',
  EUROJACKPOT: 'extNumberBoards',
  VIKINGLOTTO: 'extNumberBoards'
};
function toPayableBets(_ref2) {
  var _draw$drawNumber;
  let {
    game,
    draws,
    isSyndicate
  } = _ref2;
  const draw = draws.find(draw => draw.productItsId === game.productItsId);
  const betAmount = game.boards.reduce((price, board) => price + board.rowPrice * board.rowPriceMulti, 0) * game.drawCount;
  let betAmount2 = 0;
  switch (game.productId) {
    case productMapping.CONSTANTS.LOTTO:
      if (game.hasLotto2) {
        betAmount2 = betAmount;
      }
      break;
    case productMapping.CONSTANTS.KENO:
      betAmount2 = game.boards.reduce((price, board) => price + board.rowPrice * board.rowPriceMulti * Boolean(board.hasKungKeno), 0);
      break;
    default:
  }
  const bets = [{
    productId: game.productItsId,
    numDraws: game.drawCount,
    [boardName[game.productId]]: game.boards.map(board => toPayableBoard({
      game,
      board
    })),
    betAmountSalesGroup1: format.CurrencyAsJupiterString(betAmount),
    betAmountSalesGroup2: format.CurrencyAsJupiterString(betAmount2),
    betProperties: isSyndicate ? ['BOLAG'] : [],
    rowPriceMulti: 1,
    drawNum: (_draw$drawNumber = draw === null || draw === void 0 ? void 0 : draw.drawNumber) !== null && _draw$drawNumber !== void 0 ? _draw$drawNumber : 1 
  }];
  if (game.hasJoker) {
    var _jokerDraw$drawNumber;
    const jokerItsId = productMapping.getJokerProductId(game.productItsId);
    const jokerDraw = draws.find(draw => draw.productItsId === jokerItsId);
    bets.push({
      betAmountSalesGroup1: format.CurrencyAsJupiterString(game.joker.price),
      betAmountSalesGroup2: '0,00',
      betProperties: isSyndicate ? ['BOLAG'] : [],
      drawNum: (_jokerDraw$drawNumber = jokerDraw === null || jokerDraw === void 0 ? void 0 : jokerDraw.drawNumber) !== null && _jokerDraw$drawNumber !== void 0 ? _jokerDraw$drawNumber : 1,
      numDraws: game.drawCount,
      productId: productMapping.getJokerProductId(game.productItsId),
      rowPriceMulti: 1,
      jokerBoards: [toPayableBoard({
        game,
        board: game.joker
      })]
    });
  }
  return bets;
}
function toPayableWagers(_ref3) {
  let {
    games,
    gamesDisplayOrder,
    draws,
    gamePackageId = 0,
    isSyndicate,
    syndicate
  } = _ref3;
  return gamesDisplayOrder.map(_ref4 => {
    let {
      uniqueId
    } = _ref4;
    return _objectSpread({
      bets: toPayableBets({
        game: games.find(game => game.uniqueId === uniqueId),
        draws,
        isSyndicate
      }),
      bagType: gamePackageId
    }, isSyndicate && {
      syndicate: true,
      syndicateId: syndicate.syndicateId
    });
  });
}
function toApiWagers(_ref5) {
  let {
    next,
    gamePackageId,
    isSyndicate,
    syndicate
  } = _ref5;
  const {
    gamesDisplayOrder,
    games,
    draws
  } = svs.gamePackage.redux.store.getState().numbergames;
  const wagers = toPayableWagers({
    gamesDisplayOrder,
    games,
    draws,
    gamePackageId,
    isSyndicate,
    syndicate
  });
  next({
    draws,
    wagers
  });
}
svs.gamePackage.pay.toApiWagers = toApiWagers;

 })(window);